import { Component } from '@angular/core';
import { ALayoutMenuTab } from '../../../appbuilder/common/menutabcontrol/menu.tab.control';

@Component({
    selector: 'queries-select-menu-tab',
    templateUrl: './queries.menu.tab.html',
    styleUrls: ['./queries.menu.tab.css']
})
export class QueriesSelectMenuTab extends ALayoutMenuTab {
    Queries = [];

    onLayoutSet() {
        let queries = [];
        if (this.Layout && this.Layout.Datadescriptions) {
            queries = this.Layout.Datadescriptions;
        }
        this.Queries = queries;
    }

    queryChanged() {
        if (this.SelectedItemValue) {
            if (this.SelectedItemValue.Element && typeof this.SelectedItemValue.Element.OnDataBindingChanged === 'function') {
                this.SelectedItemValue.Element.OnDataBindingChanged();
            }
            this.onStyleChanged('Queries');
        }
    }
}
